import { Tooltip } from "@blueprintjs/core";
import React from "react";

import { FlexJustify } from "common/fragments/Flex";
import { CardView } from "common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { ImageView } from "common/views/image/Image.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IQueryMany, QueryMany } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import Config from "./Config";
import Organization from "./entities/Organization";

@Panel({id: "organizations-user", configClass: Config})
@QueryMany(Organization, {})
export default class OrganizationsPanel extends React.PureComponent<IPanelProps<Config> & IQueryMany<Organization>> {

	public render() {
		const { entities } = this.props;

		return (
			<RowsView viewKey="organizations-rows">
				{entities.map(this.renderOrganization)}
			</RowsView>
		);
	}

	private renderOrganization = ({id, name, logoURL}: Organization) => {

		const icon = <ImageView src={logoURL} style={{maxWidth: '100%'}} viewKey="logo" />;

		// TODO page link to somewhere?

		return (
			<CardView key={id} viewKey="card">
				{
					this.props.config.iconsOnly ? (
						<Tooltip content={name}>{icon}</Tooltip>
					) : (
						<FlexJustify>
							{icon}
							<div>
								<HeadingView viewKey="name" variant={HeadingVariant.H4} children={name} />
							</div>
						</FlexJustify>
					)
				}
			</CardView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/Organizations.panel.tsx